import { ButtonHTMLAttributes, MouseEvent, ReactNode } from 'react';
import { cn } from '@/ui/lib/utils';
import { sounds } from '@/utils/Sounds';
import './button.css';

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
    variant?: 'primary' | 'secondary' | 'outline' | 'ghost';
    size?: 'small' | 'medium' | 'large';
    rounding?: 'none' | 'small' | 'large';
    align?: 'left' | 'center' | 'right';
    children: ReactNode;
}

export const Button = ({
    children,
    className,
    rounding = 'small',
    variant = 'primary',
    type = 'button',
    disabled = false,
    align = 'center',
    size = 'medium',
    onClick,
    ...rest
}: ButtonProps) => {
    const handleClick = (event: MouseEvent<HTMLButtonElement>) => {
        sounds.playFX('click');
        onClick?.(event);
    };

    return (
        <button
            className={cn(
                'button',
                `button--${variant}`,
                `button--rounding-${rounding}`,
                `button--align-${align}`,
                `button--size-${size}`,
                className,
            )}
            type={type}
            disabled={disabled}
            aria-disabled={disabled}
            tabIndex={disabled ? -1 : 0}
            onClick={handleClick}
            {...rest}
        >
            {children}
        </button>
    );
};
